(function () {

    'use strict';

    function pxSelectSites(SitesProviderService, TenantListService) {
        return {
            restrict: 'EA',
            scope: {
                me: '=',
                selectedSiteIds: '=',
                onDone: '&',
                onCancel: '&'
            },
            templateUrl: 'app/components/settings/cloudStorage/selectSites/selectSites.template.html',
            link: function (scope) {

                scope.loading = false;
                scope.availableSitesTree = [];
                scope.selectedSitesTree = [];

                scope.onAvailableFolderSelected = function (folder) {
                    return true;  // Allow default action
                };

                scope.onAvailableSiteSelected = function (site) {
                    addSiteBranchToSelectedSitesTree(buildSiteBranch(site));
                    return true;  // Allow default action
                };

                scope.onSelectedFolderSelected = function (folder) {
                    return true;  // Allow default action
                };

                scope.onSelectedSiteSelected = function (site) {
                    removeSiteFromSelectedSitesTree(site);
                    return true;  // Allow default action
                };

                scope.onDoneButtonClick = function () {
                    scope.onDone({ selectedSiteIds: getSelectedSiteIds() });
                };

                scope.onCloseButtonClick = function () {
                    scope.onCancel();
                };

                scope.onOutsideClick = function () {
                    // scope.onCancel();
                };

                function getSiteTree() {
                    scope.loading = true;
                    SitesProviderService.getSitesAllSites().then(function (response) {
                        scope.availableSitesTree = angular.copy(response.tree.siteTreeFolders);
                        buildSelectedSitesTree();
                        scope.loading = false;
                    }).catch(function(error) {
                        scope.loading = false;
                    });
                }

                function buildSelectedSitesTree() {
                    scope.selectedSiteIds.forEach(siteId => {
                        addSiteBranchToSelectedSitesTree(buildSiteBranch(getTreeItemById(siteId)));
                    });
                }

                function buildSiteBranch(site) {
                    let node = null;
                    let previousNode = null;
                    for (let item = site; item; item = item.parentId ? getTreeItemById(item.parentId) : null) {
                        node = {
                            id: item.id,
                            type: item.type,
                            name: item.name,
                            parent: null,
                            children: previousNode ? [previousNode] : null
                        };
                        if (node.type === 'folder') {
                            node.open = true;
                        }
                        if (previousNode) {
                            previousNode.parent = node;
                        }
                        previousNode = node;
                    }
                    return node;
                }

                function addSiteBranchToSelectedSitesTree(branch) {
                    let items = scope.selectedSitesTree;
                    let parent = null;
                    do {
                        const foundItem = items.find(item => item.id === branch.id);
                        if (!foundItem) {
                            branch.parent = parent;
                            items.push(branch);
                            sortSiteTreeLevel(items);
                            break;
                        }
                        items = foundItem.children;
                        parent = foundItem;
                        branch = branch.children ? branch.children[0] : null;
                    } while (branch);
                }

                function sortSiteTreeLevel(items) {
                    items.sort((a, b) => {
                        if (a.type === b.type) {
                            return a.name.localeCompare(b.name);
                        } else {
                            return a.type === 'folder' ? -1 : 1;
                        }
                    });
                }

                function removeSiteFromSelectedSitesTree(site) {
                    let item;
                    for (item = site; item.parent; item = item.parent) {
                        if (item.parent.children.length > 1) {
                            const index = item.parent.children.indexOf(item);
                            item.parent.children.splice(index, 1);
                            return;
                        }
                    }
                    const index = scope.selectedSitesTree.indexOf(item);
                    scope.selectedSitesTree.splice(index, 1);
                }

                function getTreeItemById(itemId) {
                    return getTreeItemByIdRecursively(itemId, scope.availableSitesTree);
                }

                function getTreeItemByIdRecursively(itemId, items) {
                    for (const item of items) {
                        if (item.id === itemId) {
                            return item;
                        } else {
                            if (item.type === 'folder') {
                                const foundItem = getTreeItemByIdRecursively(itemId, item.children);
                                if (foundItem) return foundItem;
                            }
                        }
                    }
                    return null;
                }

                function getSelectedSiteIds() {
                    return getSiteIdsRecursively(scope.selectedSitesTree);
                }

                function getSiteIdsRecursively(items) {
                    const ids = [];
                    items.forEach(item => {
                        if (item.type === 'folder') {
                            ids.push(...getSiteIdsRecursively(item.children));
                        } else {
                            ids.push(item.id);
                        }
                    });
                    return ids;
                }

                (function () {
                    getSiteTree();
                })();

            }
        };
    }

    pxSelectSites.$inject = ['SitesProviderService', 'TenantListService'];

    angular
        .module('printix-admin')
        .directive('pxSelectSites', pxSelectSites);

})();
